import { render, staticRenderFns } from "./HighlightsGridSlide.vue?vue&type=template&id=138d087f&scoped=true&"
import script from "./HighlightsGridSlide.vue?vue&type=script&lang=js&"
export * from "./HighlightsGridSlide.vue?vue&type=script&lang=js&"
import style0 from "./HighlightsGridSlide.vue?vue&type=style&index=0&id=138d087f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d087f",
  null
  
)

export default component.exports